import { Injectable, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private sessionExpired = signal(false);
  readonly sessionExpired$ = this.sessionExpired.asReadonly();

  constructor(
    private msalService: MsalService,
    private loader: LoaderService
  ) {}

  /**
   * Single entry point for ending an invalid/expired session. Called from the
   * startup session check, the HTTP interceptor (401 / silent-token failure),
   * and the idle timeout monitor. The signal guard below ensures that if
   * several of those fire around the same time (e.g. multiple in-flight API
   * calls all get a 401), only the first one shows the message and redirects.
   */
  handleSessionTimeout(): void {
    if (this.sessionExpired()) return;
    this.sessionExpired.set(true);

    // Keep the full-screen loader up so the user is never left on a blank
    // screen while the browser navigates to the Microsoft login page.
    this.loader.show();

    this.msalService.instance.setActiveAccount(null);
    sessionStorage.clear();

    alert('Your session has expired due to inactivity. Please log in again.');

    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/'
    }).subscribe();
  }

  clearSessionExpired(): void {
    this.sessionExpired.set(false);
  }

  isSessionValid(): boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }
}
